/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { supportCreateTicket } from "../../funcs/supportCreateTicket.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateTicketRequest$inboundSchema,
};

export const tool$supportCreateTicket: ToolDefinition<typeof args> = {
  name: "support-create-ticket",
  description: `Create a support ticket for a Moov account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/tickets.write\` scope.

If you're creating the ticket on behalf of another account, then you'll need to
specify the \`/accounts/{partnerAccountID}/tickets.write\` and \`/accounts/{accountID}/profile.read\` scopes.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await supportCreateTicket(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
